import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=785b94b6&scoped=true&"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b94b6",
  null
  
)

export default component.exports